import {
  Datagrid,
  TextField,
  // SearchInput,
  TextInput,
  SelectInput,
  useTranslate,
  // FunctionField,
  // BooleanInput,
  BooleanField,
  NumberField,
  FunctionField,
} from 'react-admin'
import { ListBase } from '../../components/base'
import { DateField } from '../../components/fields'
import { COMMON_FIELDS, SERVICES_FIELDS } from '../../providers/localization/constant'

const ServicesListFilters = (): JSX.Element[] => {
  const translate = useTranslate()
  return [
    // <SearchInput
    //   key={0}
    //   source='q'
    //   alwaysOn
    //   InputLabelProps={{ shrink: true }}
    //   InputProps={{ notched: false }}
    //   placeholder={translate(`${SERVICES_FIELDS}.name`)}
    // />,
    <TextInput
      key={0}
      source='title'
      // InputLabelProps={{ shrink: true }}
      // InputProps={{ notched: false }}
      // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
      label={translate(`${SERVICES_FIELDS}.title`)}
    />,
    <SelectInput
      key={1}
      label={`${COMMON_FIELDS}.status.label`}
      source='is_active'
      choices={[
        { id: 'true', name: `${COMMON_FIELDS}.status.choices.active` },
        { id: 'false', name: `${COMMON_FIELDS}.status.choices.inActive` },
      ]}
    />,
  ]
}

const ServicesList = (): JSX.Element => {
  const translate = useTranslate()
  return (
    <ListBase
      listAction={{
        hasExport: false,
      }}
      filters={ServicesListFilters()}
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <Datagrid rowClick='edit' bulkActionButtons={false}>
        <TextField
          source='title_th'
          label={`${SERVICES_FIELDS}.title_th`}
          // sortable={false}
        ></TextField>
        <TextField
          source='title_en'
          label={`${SERVICES_FIELDS}.title_en`}
          // sortable={false}
        ></TextField>
        <TextField
          source='key'
          label={`${SERVICES_FIELDS}.key`}
          sortable={false}
        ></TextField>
        {/* <TextField
          source='type'
          label={`${SERVICES_FIELDS}.type_of_service`}
          sortable={false}
        ></TextField> */}
        <FunctionField
          source='type'
          label={`${SERVICES_FIELDS}.type_of_service.label`}
          render={({ type }): string =>
            type === 'main'
              ? translate(`${SERVICES_FIELDS}.type_of_service.service`)
              : translate(`${SERVICES_FIELDS}.type_of_service.other_service`)
          }
          // sortable={false}
        />
        <DateField
          source='create_at'
          label={`${COMMON_FIELDS}.date.created_at`}
          showTime={true}
          // textAlign='center'
        />
        <DateField
          source='update_at'
          label={`${COMMON_FIELDS}.date.updated_at`}
          showTime={true}
          // textAlign='center'
        />
        <NumberField
          source='service_duration'
          label={`${SERVICES_FIELDS}.service_duration`}
          sortable={false}
          textAlign='center'
        ></NumberField>
        <BooleanField
          source='is_active'
          label={`${COMMON_FIELDS}.status.label`}
          textAlign='center'
          sortable={false}
        />
      </Datagrid>
    </ListBase>
  )
}

export default ServicesList
